// extracted by mini-css-extract-plugin
export default {"switcher":"LanguageSwitcher_switcher__suFhY","btn":"LanguageSwitcher_btn__1fqyG","active":"LanguageSwitcher_active__wcvyc"};